<template>
  <a class="text-body font-weight-normal one-service-discount-field"
     :class="{ 'cellEditable': !readonly }">
    <span v-if="!isEditingValue"
          style="margin-right: 3px;"
          @click="discountEditable && openValueEdit()">
      {{ displayText }}
    </span>
    <input v-if="isEditingValue"
           type="number"
           ref="inputRef"
           v-model="editingValue"
           v-click-outside="closeValueEdit"
           @blur="closeValueEdit"
           @keyup.enter="closeValueEdit"
           @keyup.esc="cancelValueEdit"
           @keyup="onKeyup"
           min="0"
           class="form-control sm d-inline-block align-middle"/>
    <span v-if="!editingType"
          :class="{ 'text-decoration-none': scope === 'allServicesOfGroup' || predefinedType }"
          @click="discountEditable && canChangeType && openTypeEdit()">
      {{ discountType === 'percent' ? '%' : currencyName }}
    </span>
    <select v-if="editingType"
            style="width: 60px"
            v-click-outside="closeTypeEdit"
            class="form-control sm d-inline-block align-middle ml-2"
            :value="discountType"
            @change="changeType($event.target.value)">
      <option value="percent">%</option>
      <option value="absolute">{{ currencyName }}</option>
    </select>
  </a>
</template>

<script setup>
import { computed, inject, nextTick, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useDiscountField } from './useDiscountField'
import {formatNumber} from "@/extensions/filters/filters"

const props = defineProps({
  service: {
    type: Object,
    default: null
  },
  readonly: Boolean,
  teeth: Array,
  scope: {
    type: String,
    default: 'serviceOfGroup', // serviceOfGroup | serviceOfAllTeeth | allServicesOfGroup
  },
  predefinedType: {
    type: String,
    default: null,
  }
})

const store = useStore()
const versionCount = inject('versionCount')
const inputRef = ref(null)

const rights = computed(() => store.state.auth.rights)
const currencyName = computed(() => store.getters.getCurrencyName)
const discountEditable = computed(() => !props.readonly && rights.value.includes('edit_discounts'))

const {
  discountType,
  canChangeType,
  displayValue,
  editingValue,
  isEditingValue,
  editingType,
  openValueEdit,
  openTypeEdit,
  cancelValueEdit,
  closeValueEdit,
  closeTypeEdit,
  onKeyup,
  changeType,
} = useDiscountField({
  scope: props.scope,
  service: computed(() => props.service),
  teeth: computed(() => props.teeth),
  predefinedType: computed(() => props.predefinedType),
  versionCount,
})

const displayText = computed(() => {
  if (discountType.value === 'percent') {
    if(displayValue.value === '' || displayValue.value === 0) return '-'
  }
  return formatNumber(displayValue.value, true)
})

watch(isEditingValue, async (val) => {
  if (val) {
    await nextTick()
    inputRef.value?.focus()
  }
})
</script>
